import { render, staticRenderFns } from "./SmOwLabeledTextArea.vue?vue&type=template&id=e0f60d2e&"
import script from "./SmOwLabeledTextArea.vue?vue&type=script&lang=ts&"
export * from "./SmOwLabeledTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports